import { ConfidentialAccessLevel } from '@dreryk/egabinet-medical-data-confidentiality-frontend-api';

export const CONFIDENTIALITY_ACCESS_DURATION_DEFAULT_HOURS = 24;
export const CONFIDENTIALITY_ACCESS_DURATION_MIN_HOURS = 1;
export const CONFIDENTIALITY_ACCESS_DURATION_MAX_HOURS = 72;
export const CONFIDENTIALITY_ACCESS_LEVELS: ConfidentialAccessLevel[] = ['MONITORED', 'AUTHORIZED'];

export type ConfidentialitySettingRow = {
   accessLevel: ConfidentialAccessLevel;
   durationHours: number;
};
